import { baseApi, WHITELIST_TAG } from '@/shared';

import type {
  TWhitelist,
  TWhitelistCreateParams,
  TWhitelistUpdateParams,
} from './types';

export const whiteListApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getWhitelist: build.query<TWhitelist[], void>({
      query: () => ({
        url: '/admin/whitelist/list',
      }),
      // transformResponse: whitelistAdapter,
      providesTags: [WHITELIST_TAG],
    }),

    createWhitelist: build.mutation<void, TWhitelistCreateParams>({
      query: (params: TWhitelistCreateParams) => ({
        url: '/admin/whitelist/create',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [WHITELIST_TAG],
    }),

    updateWhitelist: build.mutation<void, TWhitelistUpdateParams>({
      query: ({ itemId, ...params }: TWhitelistUpdateParams) => ({
        url: `/admin/whitelist/update/${itemId}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: [WHITELIST_TAG],
    }),

    deleteWhitelist: build.mutation<void, { itemId: number }>({
      query: ({ itemId }) => ({
        url: `/admin/whitelist/delete/${itemId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [WHITELIST_TAG],
    }),

  }),
});

export const {
  useGetWhitelistQuery,
  useCreateWhitelistMutation,
  useUpdateWhitelistMutation,
  useDeleteWhitelistMutation,
} = whiteListApi;
